module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-500.87865e75.woff2";